import { faArrowDown, faArrowUp, faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Card, Col, Placeholder, Row } from "react-bootstrap";
import './Metrics.css';

export const MetricsTextSquare = (props: {
    title: string,
    currentMetric: any,
    percentileMetric: any,
    isLoadingCurrentMetrics: boolean,
}) => {
    return (
        <Card>
            <Card.Body>
                <Row>
                    <Col className="metrics-title">{props.title}</Col>
                </Row>
                {
                    props.currentMetric && (
                        <Row>
                            <Col xs="auto" className="metrics-value">{props.currentMetric["value"]}</Col>
                            <Col className="metrics-relative">
                                <Row>
                                    {
                                        props.isLoadingCurrentMetrics ? (
                                            <Col>
                                                <Placeholder as={Card.Text} animation="glow">
                                                    <Placeholder xs={8} /> <Placeholder xs={8} />
                                                </Placeholder>
                                            </Col>
                                        ) : (props.currentMetric["diff"] === "" || isNaN(props.currentMetric["diff"]) || props.currentMetric["diff"] === "NaN") ? (
                                            <></>
                                        ) : (
                                            <Col className={props.currentMetric["diff"] >= 0 ? "metrics-good" : "metrics-bad"}>
                                                <FontAwesomeIcon icon={props.currentMetric["diff"] >= 0 ? faArrowUp : faArrowDown} />{' '}
                                                {props.currentMetric["diff"]} ({props.currentMetric["diffPercentage"]}%){' '}
                                                <span className="metrics-mom-desc">
                                                    vs last week
                                                </span>
                                            </Col>
                                        )
                                    }
                                </Row>
                            </Col>
                        </Row>
                    )
                }
                {
                    !props.isLoadingCurrentMetrics && props.percentileMetric && props.percentileMetric["rank"] && props.percentileMetric["rank"] > 90 && 
                    <Row>
                        <Col>
                            <div className="metrics-insight">
                                <FontAwesomeIcon icon={faExclamationCircle} />{' '}<strong>{props.percentileMetric["rank"]}th percentile</strong> based on data over the past year
                            </div>
                        </Col>
                    </Row>
                }
            </Card.Body>
        </Card>
    );
};
